import type { SVGProps } from 'react'
const SvgSyArrowUpCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 2C6.487 2 2 6.487 2 12s4.487 10 10 10c5.514 0 10-4.487 10-10S17.514 2 12 2m0 1.5c4.704 0 8.5 3.797 8.5 8.5s-3.796 8.5-8.5 8.5A8.49 8.49 0 0 1 3.5 12 8.49 8.49 0 0 1 12 3.5"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M12 9.207a.75.75 0 0 0-.531.22l-3.471 3.487A.75.75 0 0 0 8 13.974a.75.75 0 0 0 1.06-.003L12 11.02l2.94 2.95a.75.75 0 0 0 1.06.005.75.75 0 0 0 .002-1.06l-3.47-3.487A.75.75 0 0 0 12 9.207" />
		</g>
	</svg>
)
export default SvgSyArrowUpCircle
